export default "__VITE_ASSET__B8Qh4Ymf__"